export const categories = [
  {
    slug: 'zuqiu',
    name: '足球',
    icon: 'ri-football-line',
    description: '全球足球赛事全覆盖，英超、西甲、欧冠、世界杯等顶级联赛实时资讯与深度分析。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20with%20dramatic%20lighting%2C%20green%20grass%20pitch%2C%20sports%20atmosphere%2C%20warm%20golden%20evening%20light%2C%20editorial%20sports%20photography%2C%20clean%20composition&width=600&height=450&seq=home-cat-zuqiu&orientation=landscape',
  },
  {
    slug: 'lanqiu',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲篮球联赛等精彩赛事，实时比分、球员数据、战术分析一应俱全。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20court%20with%20dramatic%20overhead%20lighting%2C%20polished%20hardwood%20floor%2C%20sports%20arena%20atmosphere%2C%20clean%20minimalist%20composition&width=600&height=450&seq=home-cat-lanqiu&orientation=landscape',
  },
  {
    slug: 'wangqiu',
    name: '网球',
    icon: 'ri-base-station-line',
    description: '四大满贯、ATP、WTA巡回赛，网坛巅峰对决尽在掌握，赛事直播与专业解读随时享。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20court%20with%20clay%20surface%2C%20dramatic%20sunset%20sky%2C%20clean%20court%20lines%2C%20sports%20venue%20atmosphere%2C%20warm%20golden%20hour%20lighting&width=600&height=450&seq=home-cat-wangqiu&orientation=landscape',
  },
  {
    slug: 'dianjing',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: 'LOL、DOTA2、CS2、王者荣耀等顶级电竞赛事，战队动态、比赛直播与深度复盘。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20dramatic%20stage%20lighting%2C%20gaming%20setups%20with%20RGB%20lights%2C%20modern%20competitive%20gaming%20venue&width=600&height=450&seq=home-cat-dianjing&orientation=landscape',
  },
  {
    slug: 'zonghe',
    name: '综合',
    icon: 'ri-medal-line',
    description: 'F1赛车、高尔夫、拳击、综合格斗、斯诺克等更多精彩体育项目，全方位覆盖。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20multi-sport%20collage%20style%2C%20various%20sports%20equipment%20in%20a%20clean%20modern%20studio%20setting%2C%20warm%20neutral%20lighting&width=600&height=450&seq=home-cat-zonghe&orientation=landscape',
  },
];